// Gratis cadeau-actie: aftelklok tot de einddatum. Bij 0 verdwijnt alles met data-gift-offer-expires.
if (!customElements.get('gift-offer-countdown')) {
  customElements.define(
    'gift-offer-countdown',
    class GiftOfferCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        if (!this.end) return;
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      tick() {
        const remaining = Math.max(0, this.end - Date.now());
        if (remaining === 0) {
          window.clearInterval(this.timer);
          document.querySelectorAll('[data-gift-offer-expires]').forEach((element) => {
            const dialog = element.querySelector('dialog[open]');
            if (dialog) dialog.close();
            element.hidden = true;
          });
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const pad = (value) => String(value).padStart(2, '0');
        const time = `${pad(Math.floor((totalSeconds % 86400) / 3600))}:${pad(Math.floor((totalSeconds % 3600) / 60))}:${pad(totalSeconds % 60)}`;
        this.textContent = days > 0 ? `${days}${this.dataset.day} ${time}` : time;
      }
    }
  );
}

// Links naar '#gratis-cadeau' (bijv. de kaart in de hero) openen de cadeau-pop-up.
// Staat de pop-up er niet (actie voorbij), dan werkt de link gewoon als normale link.
if (!window.__giftOfferHashLinks) {
  window.__giftOfferHashLinks = true;
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="#gratis-cadeau"]');
      if (!link) return;
      const popup = document.querySelector('gift-offer-popup');
      if (!popup || popup.hidden || typeof popup.open !== 'function') return;
      event.preventDefault();
      popup.open(true);
    },
    true
  );
}
